module.exports = __webpack_public_path__ + "img/clock.57d31b68.svg";